/**
 * Why Guests Love It — same /api/public/reviews channel as customer-reviews-text.
 * Renders a horizontal snap carousel of review cards.
 */
(function () {
  function init(root) {
    if (!root || root.dataset.amcPoLoveInit === '1') return;
    root.dataset.amcPoLoveInit = '1';

    var track = root.querySelector('[data-amc-po-love-track]');
    var empty = root.querySelector('[data-amc-po-love-empty]');
    var scoreEl = root.querySelector('[data-amc-po-love-score]');
    var countEl = root.querySelector('[data-amc-po-love-count]');
    var metaScoreEls = document.querySelectorAll('[data-amc-po-rating-score]');
    var metaCountEls = document.querySelectorAll('[data-amc-po-rating-count]');
    var prevBtn = root.querySelector('[data-amc-po-love-prev]');
    var nextBtn = root.querySelector('[data-amc-po-love-next]');
    if (!track) return;

    var apiUrl = (root.getAttribute('data-api-base-url') || 'https://amc-ew.aogen.com.au').trim();
    var shopDomain = root.getAttribute('data-shop-domain') || root.getAttribute('data-shop-domain-fallback') || '';
    var locationId = root.getAttribute('data-location-id') || '';
    var reviewsMode = (root.getAttribute('data-reviews-mode') || 'workshop').trim();
    var pageWorkshopType = (root.getAttribute('data-workshop-type') || '').trim();
    var sortOrder = root.getAttribute('data-sort-order') || 'newest_first';
    var minRating = parseFloat(root.getAttribute('data-min-rating') || '1');
    var maxReviews = parseInt(root.getAttribute('data-max-reviews'), 10) || 12;
    var requireVerifiedOnly = root.getAttribute('data-require-verified-only') === 'true';

    var apiWorkshopTypeQueryMap = {};
    try {
      apiWorkshopTypeQueryMap = JSON.parse(root.getAttribute('data-api-workshop-type-query-map') || '{}');
    } catch (e) {
      apiWorkshopTypeQueryMap = {};
    }

    function escapeHtml(value) {
      return String(value || '').replace(/[&<>"']/g, function (ch) {
        return ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' })[ch];
      });
    }

    function buildUrl(endpoint) {
      if (/^https?:\/\//i.test(endpoint || '')) return endpoint;
      return apiUrl.replace(/\/$/, '') + '/' + String(endpoint || '').replace(/^\//, '');
    }

    function apiWorkshopQueryKey(canonical) {
      var c = String(canonical || '').trim();
      if (!c) return '';
      var lower = c.toLowerCase();
      var mapped = apiWorkshopTypeQueryMap[c] != null ? apiWorkshopTypeQueryMap[c] : apiWorkshopTypeQueryMap[lower];
      if (mapped != null && String(mapped).trim() !== '') return String(mapped).trim();
      return lower;
    }

    function normalizeType(raw) {
      var t = String(raw || '').toLowerCase().trim();
      if (t.indexOf('mosaic') > -1) return 'mosaic';
      if (t.indexOf('resin') > -1) return 'resin';
      if (t.indexOf('ceramic') > -1) return 'ceramic';
      if (t.indexOf('flower') > -1) return 'flower';
      return 'all';
    }

    function resolvePhotoUrl(item) {
      if (!item || typeof item !== 'object') return '';
      var fields = [
        item.author_photo,
        item.profile_photo_url,
        item.profile_photo,
        item.author_image,
        item.avatar_url
      ];
      for (var i = 0; i < fields.length; i++) {
        var raw = fields[i];
        if (!raw) continue;
        if (typeof raw === 'string' && raw.trim()) return raw.trim();
        if (typeof raw === 'object' && raw.value != null && String(raw.value).trim()) {
          return String(raw.value).trim();
        }
      }
      return '';
    }

    function formatReviewDate(unix, relative) {
      if (relative && String(relative).trim()) {
        return String(relative)
          .trim()
          .replace(/\s+on\s+(Google|Website)\s*$/i, '')
          .trim();
      }
      var n = Number(unix);
      if (!n || !Number.isFinite(n)) return '';
      if (n > 1e12) n = Math.floor(n / 1000);
      var d = new Date(n * 1000);
      if (Number.isNaN(d.getTime())) return '';
      try {
        return d.toLocaleDateString('en-US', { month: 'short', day: 'numeric', year: 'numeric' });
      } catch (e) {
        return '';
      }
    }

    function mapItem(item) {
      var rawT = item.review_time !== undefined && item.review_time !== null ? item.review_time : item.time;
      var rel = item.relative_time || item.time_description || '';
      if (typeof rawT === 'string' && String(rawT).trim() && isNaN(parseInt(rawT, 10))) {
        rel = rel || String(rawT).trim();
        rawT = 0;
      }
      return {
        rating: Number(item.rating || 0),
        workshop_type: (function () {
          if (item.workshop_type) return normalizeType(item.workshop_type);
          var types = item.workshop_types;
          if (Array.isArray(types) && types.length) return normalizeType(types[0]);
          return 'all';
        })(),
        author_name: item.author_name || item.author || 'Anonymous',
        author_photo: resolvePhotoUrl(item),
        text: item.text || item.review_text || '',
        time: parseInt(rawT, 10) || 0,
        relative_time: rel,
        source: (item.source || item.provider || 'google').toLowerCase(),
        verified_purchase: Boolean(item.verified_purchase || item.purchase_verified)
      };
    }

    function filterReviews(list) {
      var rated = (Array.isArray(list) ? list : []).filter(function (r) {
        if (Number(r.rating || 0) < minRating) return false;
        if (!String(r.text || '').trim()) return false;
        if (reviewsMode === 'workshop' && requireVerifiedOnly) {
          return r.source !== 'site' || Boolean(r.verified_purchase);
        }
        return true;
      });
      if (reviewsMode === 'workshop' && pageWorkshopType) {
        var pri = rated.filter(function (r) {
          return r.workshop_type === pageWorkshopType;
        });
        if (pri.length) return pri;
      }
      return rated;
    }

    function starsHtml(rating) {
      var n = Math.round(Number(rating) || 0);
      if (n < 0) n = 0;
      if (n > 5) n = 5;
      var out = '';
      for (var i = 0; i < 5; i++) {
        out += i < n ? '★' : '☆';
      }
      return out;
    }

    function updateSummary(avg, count) {
      if (Number.isFinite(avg) && scoreEl) {
        scoreEl.textContent = avg.toFixed(1);
      }
      if (Number.isFinite(count) && countEl) {
        var label = Math.round(count) === 1 ? '1 review' : Math.round(count) + ' reviews';
        countEl.textContent = '(' + label + ')';
      }
      if (Number.isFinite(avg) && metaScoreEls.length) {
        metaScoreEls.forEach(function (el) {
          el.textContent = avg.toFixed(1);
        });
      }
      if (Number.isFinite(count) && metaCountEls.length) {
        var metaLabel = Math.round(count) === 1 ? '1 review' : Math.round(count) + ' reviews';
        metaCountEls.forEach(function (el) {
          el.textContent = '(' + metaLabel + ')';
        });
      }
    }

    function cardHtml(review) {
      var when = formatReviewDate(review.time, review.relative_time);
      var photo = review.author_photo
        ? '<img class="amc-po__quote-avatar" src="' + escapeHtml(review.author_photo) + '" alt="" width="40" height="40" loading="lazy" decoding="async" referrerpolicy="no-referrer">'
        : '<span class="amc-po__quote-avatar amc-po__quote-avatar--fallback" aria-hidden="true">' +
          escapeHtml(String(review.author_name || '?').charAt(0).toUpperCase()) +
          '</span>';
      var text = String(review.text || '').trim();
      return (
        '<article class="amc-po__quote amc-po__love-slide" data-amc-po-love-slide>' +
        '<div class="amc-po__quote-person">' +
        photo +
        '<div class="amc-po__quote-person-text">' +
        '<p class="amc-po__quote-name">' +
        escapeHtml(review.author_name) +
        '</p>' +
        (when
          ? '<p class="amc-po__quote-meta">' + escapeHtml(when) + '</p>'
          : '') +
        '</div>' +
        '</div>' +
        '<div class="amc-po__quote-body">' +
        '<p class="amc-po__quote-text amc-po__quote-text--clamp" data-amc-po-love-text>“' +
        escapeHtml(text) +
        '”</p>' +
        '<button type="button" class="amc-po__quote-more" data-amc-po-love-expand hidden aria-expanded="false">Show more</button>' +
        '</div>' +
        '</article>'
      );
    }

    function syncTextClamps() {
      track.querySelectorAll('[data-amc-po-love-slide]').forEach(function (slide) {
        var textEl = slide.querySelector('[data-amc-po-love-text]');
        var btn = slide.querySelector('[data-amc-po-love-expand]');
        if (!textEl || !btn) return;
        textEl.classList.add('amc-po__quote-text--clamp');
        textEl.classList.remove('is-expanded');
        btn.hidden = true;
        btn.textContent = 'Show more';
        btn.setAttribute('aria-expanded', 'false');
        requestAnimationFrame(function () {
          btn.hidden = !(textEl.scrollHeight > textEl.clientHeight + 1);
        });
      });
    }

    function bindExpand() {
      track.addEventListener('click', function (e) {
        var btn = e.target.closest('[data-amc-po-love-expand]');
        if (!btn || !track.contains(btn)) return;
        var slide = btn.closest('[data-amc-po-love-slide]');
        var textEl = slide && slide.querySelector('[data-amc-po-love-text]');
        if (!textEl) return;
        var expanded = textEl.classList.toggle('is-expanded');
        btn.textContent = expanded ? 'Show less' : 'Show more';
        btn.setAttribute('aria-expanded', expanded ? 'true' : 'false');
      });
    }

    function updateNav() {
      if (!prevBtn && !nextBtn) return;
      var max = Math.max(0, track.scrollWidth - track.clientWidth);
      var left = track.scrollLeft;
      if (prevBtn) prevBtn.disabled = left <= 4;
      if (nextBtn) nextBtn.disabled = left >= max - 4;
      var showNav = max > 4;
      if (prevBtn) prevBtn.hidden = !showNav;
      if (nextBtn) nextBtn.hidden = !showNav;
    }

    function step() {
      var slide = track.querySelector('[data-amc-po-love-slide]');
      if (!slide) return 0;
      var gap = parseFloat(getComputedStyle(track).gap) || 0;
      return slide.getBoundingClientRect().width + gap;
    }

    function bindCarousel() {
      if (prevBtn) {
        prevBtn.addEventListener('click', function () {
          track.scrollBy({ left: -step(), behavior: 'smooth' });
        });
      }
      if (nextBtn) {
        nextBtn.addEventListener('click', function () {
          track.scrollBy({ left: step(), behavior: 'smooth' });
        });
      }
      track.addEventListener('scroll', updateNav, { passive: true });
      window.addEventListener('resize', updateNav);
      updateNav();
    }

    function render(reviews, aggregate) {
      var list = filterReviews(reviews).slice(0, maxReviews);
      if (!list.length) {
        track.innerHTML = '';
        if (empty) {
          empty.hidden = false;
          empty.textContent = 'No reviews yet.';
        }
        updateNav();
        return;
      }
      if (empty) empty.hidden = true;
      track.innerHTML = list.map(cardHtml).join('');
      syncTextClamps();

      var avg =
        aggregate && aggregate.avg_rating != null && Number.isFinite(Number(aggregate.avg_rating))
          ? Number(aggregate.avg_rating)
          : list.reduce(function (sum, r) {
              return sum + Number(r.rating || 0);
            }, 0) / list.length;
      var count =
        aggregate && aggregate.review_count != null && Number.isFinite(Number(aggregate.review_count))
          ? Number(aggregate.review_count)
          : list.length;
      updateSummary(avg, count);
      updateNav();
    }

    function fetchReviews() {
      if (!shopDomain) {
        if (empty) {
          empty.hidden = false;
          empty.textContent = 'Unable to load reviews right now.';
        }
        return;
      }

      var params = new URLSearchParams();
      params.set('shop_domain', shopDomain);
      if (locationId && locationId !== 'all') params.set('location_id', locationId);
      if (reviewsMode === 'workshop') {
        params.set('status', 'approved');
        params.set('include_google', 'true');
        params.set('include_site', 'true');
        if (pageWorkshopType) {
          var queryWT = apiWorkshopQueryKey(pageWorkshopType);
          if (queryWT) params.set('workshop_type', queryWT);
        }
      }
      params.set('sort', sortOrder);
      params.set('limit', String(maxReviews));
      params.set('offset', '0');

      fetch(buildUrl('/api/public/reviews') + '?' + params.toString())
        .then(function (res) {
          return res.ok ? res.json() : Promise.reject(new Error('Request failed'));
        })
        .then(function (payload) {
          var listData = Array.isArray(payload) ? payload : payload.reviews || [];
          var aggregate = payload && payload.aggregate ? payload.aggregate : null;
          var mapped = listData.map(mapItem);
          if (pageWorkshopType) {
            mapped = mapped.map(function (r) {
              if (r.workshop_type !== 'all') return r;
              var next = Object.assign({}, r);
              next.workshop_type = normalizeType(pageWorkshopType);
              return next;
            });
          }
          render(mapped, aggregate);
        })
        .catch(function () {
          track.innerHTML = '';
          if (empty) {
            empty.hidden = false;
            empty.textContent = 'Unable to load reviews right now.';
          }
        });
    }

    bindCarousel();
    bindExpand();
    window.addEventListener('resize', syncTextClamps);
    fetchReviews();
  }

  function boot(scope) {
    (scope || document).querySelectorAll('[data-amc-po-love]').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      boot();
    });
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', function (e) {
    if (e.target) boot(e.target);
  });
})();
